import { AddMainImageRequest, InventoryActions } from "../domain/inventory";
import { addMainImageService } from "../infrastructure/services/addMainImageService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const addMainImage = {
  async execute(
    reference: string,
    description: string,
    image: File,
    isEdit: string
  ): Promise<void> {
    const request: AddMainImageRequest =
      await InventoryActions().addMainImageRequest(
        reference,
        description,
        image,
        isEdit
      );
    await addMainImageService.execute(await tokenValidation.execute(), request);
  },
};
